export const getRefreshRoute = state => state?.widgets?.refreshRoute || null;

export const getIsOnline = state => state?.widgets?.isOnline ?? true;

export const getHealthcheckError = state => state?.widgets?.healthcheckError ?? null;
